// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bg-page: #ebedef;
    --white: #ffffff;
    --text-main: #3c4b64;
    --text-muted: #8a93a2;
    --border-color: #d8dbe0;
    --primary: #4318FF;
    --info: #39f1fa;
    --warning: #f9b115;
    --danger: #e55353;
    --success: #2eb85c;
    --radius: 12px;
    --shadow: 0 1px 2px rgba(0,0,0,0.075);
}

/* Base & Layout */
.dashboard-wrapper {
    min-height: 100vh;
    font-family: 'Inter', -apple-system, sans-serif;
    color: var(--text-main);
}

.dashboard-content {
    padding: 24px 30px;
    max-width: 1600px;
    margin: 0 auto;
}

/* Banner (image_bdf29b.png) */
.dashboard-banner {
    background: linear-gradient(90deg, #321fdb 0%, #1f1498 100%);
    padding: 35px 40px;
    border-radius: var(--radius);
    color: white;
    margin-bottom: 30px;
    position: relative;
    box-shadow: 0 4px 20px rgba(50, 31, 219, 0.2);
}

.banner-title h1 {
    margin: 0;
    font-size: 1.8rem;
    font-weight: 800;
}

.banner-info p {
    margin-top: 8px;
    opacity: 0.85;
    font-size: 0.95rem;
}

/* Stats Cards (Compact & Professional) */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 24px;
    margin-bottom: 30px;
}

.stat-card {
    background: var(--white);
    padding: 20px;
    border-radius: var(--radius);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 4px solid transparent;
    transition: transform 0.2s;
    box-shadow: var(--shadow);
}

.stat-card:hover {
    transform: translateY(-3px);
}

.stat-number {
    display: block;
    font-size: 1.75rem;
    font-weight: 800;
    line-height: 1.2;
}

.stat-label {
    color: var(--text-muted);
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Main Dashboard Grid */
.dashboard-main-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
}

@media (min-width: 992px) {
    .dashboard-main-grid {
        grid-template-columns: 1.8fr 1.2fr; /* Ratio idéal pour le tableau et le staff */
    }
}

.content-card {
    background: var(--white);
    border-radius: var(--radius);
    border: 1px solid var(--border-color);
    box-shadow: var(--shadow);
    display: flex;
    flex-direction: column;
}

.card-header {
    padding: 16px 20px;
    border-bottom: 1px solid var(--border-color);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-header h3 {
    margin: 0;
    font-size: 1.05rem;
    font-weight: 700;
}

/* Tables (Ventes Récentes) */
.table-container {
    overflow-x: auto;
}

table {
    width: 100%;
    border-collapse: collapse;
}

th {
    background: #f8f9fa;
    text-align: left;
    padding: 14px 20px;
    color: var(--text-muted);
    font-size: 0.7rem;
    font-weight: 800;
    text-transform: uppercase;
}

td {
    padding: 14px 20px;
    border-top: 1px solid #f1f1f1;
    font-size: 0.9rem;
}

.client-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.avatar-circle {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: var(--bg-page);
    color: var(--primary);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 0.8rem;
}

.amount {
    font-weight: 800;
}

/* Status Chips */
.status-chip {
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 0.7rem;
    font-weight: 800;
    text-transform: uppercase;
}

.status-chip.success {
    background: rgba(46, 184, 92, 0.15);
    color: var(--success);
}

/* Staff List (Adapté image_bd9b72.png) */
.staff-list {
    padding: 15px;
}

.staff-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border-radius: 10px;
    border: 1px solid transparent;
    transition: all 0.2s;
    margin-bottom: 8px;
}

.staff-item:hover {
    background: #f8f9fa;
    border-color: var(--border-color);
}

.avatar-badge {
    position: relative;
}

.avatar-badge img {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    border: 1px solid var(--border-color);
}

.status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #abb1b6;
    position: absolute;
    bottom: 2px;
    right: 2px;
    border: 2px solid white;
}

.status-dot.online {
    background: var(--success);
}

.staff-details {
    flex-grow: 1;
}

.staff-name {
    margin: 0;
    font-weight: 700;
    font-size: 0.9rem;
}

.staff-role {
    margin: 0;
    font-size: 0.75rem;
    color: var(--text-muted);
}

/* Buttons */
.btn-outline {
    background: white;
    border: 1px solid var(--primary);
    color: var(--primary);
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    transition: 0.2s;
}

.btn-outline:hover {
    background: var(--primary);
    color: white;
}

.chat-btn {
    background: transparent;
    border: 1px solid #e0e0e0;
    color: var(--primary);
    width: 34px;
    height: 34px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.2s;
}

.chat-btn:hover {
    background: var(--bg-page);
    border-color: var(--primary);
}

/* Grille secondaire pour Offres et Ateliers */
.dashboard-secondary-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    margin-top: 24px;
}

@media (min-width: 1200px) {
    .dashboard-secondary-grid {
        grid-template-columns: 1fr 1fr;
    }
}

/* Style des Offres (image_bd9b72.png style) */
.offers-list {
    padding: 15px;
}

.offer-item {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 10px;
    margin-bottom: 12px;
    border: 1px solid transparent;
    transition: 0.2s;
}

.offer-item:hover {
    border-color: var(--primary);
    background: white;
    box-shadow: var(--shadow);
}

.offer-intervenant-img {
    width: 45px;
    height: 45px;
    border-radius: 8px;
    object-fit: cover;
}

.offer-details {
    flex-grow: 1;
}

.offer-title {
    margin: 0;
    font-weight: 700;
    font-size: 0.9rem;
    color: var(--text-main);
}

.offer-subtitle {
    margin: 0;
    font-size: 0.75rem;
    color: var(--text-muted);
    text-transform: capitalize;
}

.offer-price-tag {
    background: white;
    padding: 5px 10px;
    border-radius: 6px;
    font-weight: 800;
    color: var(--primary);
    border: 1px solid #eee;
}

/* Style des Ateliers */
.workshops-list {
    padding: 15px;
}

.workshop-item {
    display: flex;
    gap: 15px;
    padding: 15px;
    border-bottom: 1px solid #f1f1f1;
}

.workshop-item:last-child {
    border-bottom: none;
}

.workshop-icon-box {
    width: 40px;
    height: 40px;
    background: rgba(249, 177, 21, 0.1);
    color: var(--warning);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.workshop-info {
    flex-grow: 1;
}

.workshop-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
}

.workshop-name {
    margin: 0;
    font-weight: 700;
    font-size: 0.9rem;
}

.workshop-duration {
    font-size: 0.7rem;
    background: #eee;
    padding: 2px 6px;
    border-radius: 4px;
    color: var(--text-main);
}

.workshop-desc {
    margin: 0 0 8px 0;
    font-size: 0.8rem;
    color: var(--text-muted);
    line-height: 1.4;
}

.workshop-footer {
    display: flex;
    gap: 15px;
    font-size: 0.75rem;
    font-weight: 700;
}

.workshop-price {
    color: var(--success);
}

.workshop-cap {
    color: var(--text-muted);
}

/* Style du conteneur de produit */
.product-info {
    display: flex;
    flex-direction: column;
    max-width: 300px; /* Limite la largeur pour forcer le truncate */
}

.product-label {
    font-weight: 700;
    color: #1B2559;
    font-size: 14px;
    margin-bottom: 2px;
}

/* Description tronquée sur une seule ligne */
.product-description {
    font-size: 12px;
    color: #A3AED0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Style pour la date */
.date-cell {
    font-size: 13px;
    color: #707EAE;
    font-weight: 500;
    min-width: 130px;
}

/* Status colors */
.status-chip.success {
    background-color: #E6F9F0;
    color: #05CD99;
    padding: 4px 12px;
    border-radius: 20px;
    font-weight: 700;
    font-size: 12px;
}

/* Optionnel : Si tu veux autoriser 2 lignes avant de tronquer */
/*
.product-description {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
}
*/`, "",{"version":3,"sources":["webpack://./src/pages/DashboardUse/DashboardPremium.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,qCAAqC;AACzC;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,+CAA+C;IAC/C,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA,8BAA8B;AAC9B;IACI,4DAA4D;IAC5D,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,4BAA4B;IAC5B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oCAAoC;IACpC,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI;QACI,kCAAkC,EAAE,4CAA4C;IACpF;AACJ;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;IAC5B,qCAAqC;IACrC,yBAAyB;IACzB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,4CAA4C;IAC5C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA,yCAAyC;AACzC;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA,YAAY;AACZ;IACI,iBAAiB;IACjB,gCAAgC;IAChC,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA,8CAA8C;AAC9C;IACI,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA,8CAA8C;AAC9C;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB,EAAE,8CAA8C;AACpE;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA,6CAA6C;AAC7C;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,gEAAgE;AAChE;;;;;;;;CAQC","sourcesContent":[":root {\n    --bg-page: #ebedef;\n    --white: #ffffff;\n    --text-main: #3c4b64;\n    --text-muted: #8a93a2;\n    --border-color: #d8dbe0;\n    --primary: #4318FF;\n    --info: #39f1fa;\n    --warning: #f9b115;\n    --danger: #e55353;\n    --success: #2eb85c;\n    --radius: 12px;\n    --shadow: 0 1px 2px rgba(0,0,0,0.075);\n}\n\n/* Base & Layout */\n.dashboard-wrapper {\n    min-height: 100vh;\n    font-family: 'Inter', -apple-system, sans-serif;\n    color: var(--text-main);\n}\n\n.dashboard-content {\n    padding: 24px 30px;\n    max-width: 1600px;\n    margin: 0 auto;\n}\n\n/* Banner (image_bdf29b.png) */\n.dashboard-banner {\n    background: linear-gradient(90deg, #321fdb 0%, #1f1498 100%);\n    padding: 35px 40px;\n    border-radius: var(--radius);\n    color: white;\n    margin-bottom: 30px;\n    position: relative;\n    box-shadow: 0 4px 20px rgba(50, 31, 219, 0.2);\n}\n\n.banner-title h1 {\n    margin: 0;\n    font-size: 1.8rem;\n    font-weight: 800;\n}\n\n.banner-info p {\n    margin-top: 8px;\n    opacity: 0.85;\n    font-size: 0.95rem;\n}\n\n/* Stats Cards (Compact & Professional) */\n.stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 24px;\n    margin-bottom: 30px;\n}\n\n.stat-card {\n    background: var(--white);\n    padding: 20px;\n    border-radius: var(--radius);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 4px solid transparent;\n    transition: transform 0.2s;\n    box-shadow: var(--shadow);\n}\n\n.stat-card:hover {\n    transform: translateY(-3px);\n}\n\n.stat-number {\n    display: block;\n    font-size: 1.75rem;\n    font-weight: 800;\n    line-height: 1.2;\n}\n\n.stat-label {\n    color: var(--text-muted);\n    font-size: 0.75rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* Main Dashboard Grid */\n.dashboard-main-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 24px;\n}\n\n@media (min-width: 992px) {\n    .dashboard-main-grid {\n        grid-template-columns: 1.8fr 1.2fr; /* Ratio idéal pour le tableau et le staff */\n    }\n}\n\n.content-card {\n    background: var(--white);\n    border-radius: var(--radius);\n    border: 1px solid var(--border-color);\n    box-shadow: var(--shadow);\n    display: flex;\n    flex-direction: column;\n}\n\n.card-header {\n    padding: 16px 20px;\n    border-bottom: 1px solid var(--border-color);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.card-header h3 {\n    margin: 0;\n    font-size: 1.05rem;\n    font-weight: 700;\n}\n\n/* Tables (Ventes Récentes) */\n.table-container {\n    overflow-x: auto;\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n}\n\nth {\n    background: #f8f9fa;\n    text-align: left;\n    padding: 14px 20px;\n    color: var(--text-muted);\n    font-size: 0.7rem;\n    font-weight: 800;\n    text-transform: uppercase;\n}\n\ntd {\n    padding: 14px 20px;\n    border-top: 1px solid #f1f1f1;\n    font-size: 0.9rem;\n}\n\n.client-info {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.avatar-circle {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: var(--bg-page);\n    color: var(--primary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 800;\n    font-size: 0.8rem;\n}\n\n.amount {\n    font-weight: 800;\n}\n\n/* Status Chips */\n.status-chip {\n    padding: 4px 10px;\n    border-radius: 6px;\n    font-size: 0.7rem;\n    font-weight: 800;\n    text-transform: uppercase;\n}\n\n.status-chip.success {\n    background: rgba(46, 184, 92, 0.15);\n    color: var(--success);\n}\n\n/* Staff List (Adapté image_bd9b72.png) */\n.staff-list {\n    padding: 15px;\n}\n\n.staff-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px;\n    border-radius: 10px;\n    border: 1px solid transparent;\n    transition: all 0.2s;\n    margin-bottom: 8px;\n}\n\n.staff-item:hover {\n    background: #f8f9fa;\n    border-color: var(--border-color);\n}\n\n.avatar-badge {\n    position: relative;\n}\n\n.avatar-badge img {\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    border: 1px solid var(--border-color);\n}\n\n.status-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #abb1b6;\n    position: absolute;\n    bottom: 2px;\n    right: 2px;\n    border: 2px solid white;\n}\n\n.status-dot.online {\n    background: var(--success);\n}\n\n.staff-details {\n    flex-grow: 1;\n}\n\n.staff-name {\n    margin: 0;\n    font-weight: 700;\n    font-size: 0.9rem;\n}\n\n.staff-role {\n    margin: 0;\n    font-size: 0.75rem;\n    color: var(--text-muted);\n}\n\n/* Buttons */\n.btn-outline {\n    background: white;\n    border: 1px solid var(--primary);\n    color: var(--primary);\n    padding: 6px 12px;\n    border-radius: 6px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    transition: 0.2s;\n}\n\n.btn-outline:hover {\n    background: var(--primary);\n    color: white;\n}\n\n.chat-btn {\n    background: transparent;\n    border: 1px solid #e0e0e0;\n    color: var(--primary);\n    width: 34px;\n    height: 34px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: 0.2s;\n}\n\n.chat-btn:hover {\n    background: var(--bg-page);\n    border-color: var(--primary);\n}\n\n/* Grille secondaire pour Offres et Ateliers */\n.dashboard-secondary-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 24px;\n    margin-top: 24px;\n}\n\n@media (min-width: 1200px) {\n    .dashboard-secondary-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n/* Style des Offres (image_bd9b72.png style) */\n.offers-list {\n    padding: 15px;\n}\n\n.offer-item {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    padding: 12px;\n    background: #f8f9fa;\n    border-radius: 10px;\n    margin-bottom: 12px;\n    border: 1px solid transparent;\n    transition: 0.2s;\n}\n\n.offer-item:hover {\n    border-color: var(--primary);\n    background: white;\n    box-shadow: var(--shadow);\n}\n\n.offer-intervenant-img {\n    width: 45px;\n    height: 45px;\n    border-radius: 8px;\n    object-fit: cover;\n}\n\n.offer-details {\n    flex-grow: 1;\n}\n\n.offer-title {\n    margin: 0;\n    font-weight: 700;\n    font-size: 0.9rem;\n    color: var(--text-main);\n}\n\n.offer-subtitle {\n    margin: 0;\n    font-size: 0.75rem;\n    color: var(--text-muted);\n    text-transform: capitalize;\n}\n\n.offer-price-tag {\n    background: white;\n    padding: 5px 10px;\n    border-radius: 6px;\n    font-weight: 800;\n    color: var(--primary);\n    border: 1px solid #eee;\n}\n\n/* Style des Ateliers */\n.workshops-list {\n    padding: 15px;\n}\n\n.workshop-item {\n    display: flex;\n    gap: 15px;\n    padding: 15px;\n    border-bottom: 1px solid #f1f1f1;\n}\n\n.workshop-item:last-child {\n    border-bottom: none;\n}\n\n.workshop-icon-box {\n    width: 40px;\n    height: 40px;\n    background: rgba(249, 177, 21, 0.1);\n    color: var(--warning);\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.workshop-info {\n    flex-grow: 1;\n}\n\n.workshop-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 4px;\n}\n\n.workshop-name {\n    margin: 0;\n    font-weight: 700;\n    font-size: 0.9rem;\n}\n\n.workshop-duration {\n    font-size: 0.7rem;\n    background: #eee;\n    padding: 2px 6px;\n    border-radius: 4px;\n    color: var(--text-main);\n}\n\n.workshop-desc {\n    margin: 0 0 8px 0;\n    font-size: 0.8rem;\n    color: var(--text-muted);\n    line-height: 1.4;\n}\n\n.workshop-footer {\n    display: flex;\n    gap: 15px;\n    font-size: 0.75rem;\n    font-weight: 700;\n}\n\n.workshop-price {\n    color: var(--success);\n}\n\n.workshop-cap {\n    color: var(--text-muted);\n}\n\n/* Style du conteneur de produit */\n.product-info {\n    display: flex;\n    flex-direction: column;\n    max-width: 300px; /* Limite la largeur pour forcer le truncate */\n}\n\n.product-label {\n    font-weight: 700;\n    color: #1B2559;\n    font-size: 14px;\n    margin-bottom: 2px;\n}\n\n/* Description tronquée sur une seule ligne */\n.product-description {\n    font-size: 12px;\n    color: #A3AED0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* Style pour la date */\n.date-cell {\n    font-size: 13px;\n    color: #707EAE;\n    font-weight: 500;\n    min-width: 130px;\n}\n\n/* Status colors */\n.status-chip.success {\n    background-color: #E6F9F0;\n    color: #05CD99;\n    padding: 4px 12px;\n    border-radius: 20px;\n    font-weight: 700;\n    font-size: 12px;\n}\n\n/* Optionnel : Si tu veux autoriser 2 lignes avant de tronquer */\n/*\n.product-description {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    white-space: normal;\n}\n*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
